import moment from 'moment';
import { T } from '../../helpers/i18n';
var DiscountCode = /** @class */ (function () {
    function DiscountCode(props) {
        Object.assign(this, props);
        if (props.typeDiscount) {
            this.typeDiscount = T(props.typeDiscount);
        }
        if (props.start_at) {
            var start_at = new Date(props.start_at);
            if (props.year_start) {
                start_at.setMonth(props.year_start);
            }
            if (props.month_start) {
                start_at.setMonth(props.month_start);
            }
            if (props.day_start) {
                start_at.setDate(props.day_start);
            }
            this.start = moment(start_at).format('DD/MM/YYYY');
        }
        if (props.expire_at) {
            var expire_at = new Date(props.expire_at);
            if (props.year_expire) {
                expire_at.setMonth(props.year_expire);
            }
            if (props.month_expire) {
                expire_at.setMonth(props.month_expire);
            }
            if (props.day_expire) {
                expire_at.setDate(props.day_expire);
            }
            this.expire = moment(expire_at).format('DD/MM/YYYY');
        }
        if (props.disabled_at) {
            var disabled_at = new Date(props.disabled_at);
            if (props.year_disabled) {
                disabled_at.setMonth(props.year_disabled);
            }
            if (props.month_disabled) {
                disabled_at.setMonth(props.month_disabled);
            }
            if (props.day_disabled) {
                disabled_at.setDate(props.day_disabled);
            }
            this.disabled = true;
        }
    }
    return DiscountCode;
}());
export default DiscountCode;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountCodes/DiscountCode.ts
// module id = 748
// module chunks = 0